module.exports = __webpack_public_path__ + "static/media/Himpunan Mahasiswa Ilmu Komunikasi (HIMNI) Universitas Pakuan.87346c4a.png";